// extracted by mini-css-extract-plugin
export default {"cvError":"l7-z"};